module.exports = __webpack_public_path__ + "static/service-section02-img-33ccadf3680299bd2e3ad1242a0e20b0.png";